import { Injectable } from "@angular/core";

export interface SupportServiceConfig {
  restServer: string;
}

export interface PagedResponse {
  count: number;
  next: string;
  previous: string;
  results: unknown[]
}

export interface FAQs {
  question: string;
  answer: string;
  selected?: boolean;
}

export interface Help {
  subject: string;
  help_text: string;
}

@Injectable({
  providedIn: 'root',
})

export class SupportServiceTypes {

}